/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ClientPortalUserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { RootState } from "setup/redux/RootReducer";
import { actions } from "app/modules/auth";

type HeaderUserMenuProps = {
  iconClassName?: string;
};

const HeaderUserMenu: FC<HeaderUserMenuProps> = ({ iconClassName = "toolbar-icon" }) => {
  const user: ClientPortalUserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as ClientPortalUserModel;

  const dispatch = useDispatch();
  const logout = () => {
    dispatch(actions.logout());
  };
  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        as="button"
        type="button"
        bsPrefix="btn"
        className="btn-icon p-0 border-0 bg-transparent d-flex align-items-center justify-content-center w-45px h-45px"
        aria-label="Account menu"
        data-test-id="navbar__user-menu-toggle"
      >
        <FontAwesomeIcon icon={faUser as IconProp} size="xl" className={iconClassName} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-state-bg menu-state-primary fw-semibold py-4 fs-6 min-w-275px mw-350px overflow-hidden text-truncate">
        <div className="menu-item px-3 pt-0">
          <div className="menu-content d-flex align-items-center px-3">
            <div className="fw-bold d-flex align-items-center fs-5 text-truncate">{user.emailAddress}</div>
          </div>
        </div>

        <div className="separator my-2"></div>

        <div className="menu-item px-2 my-1">
          <Link to="/account/accountdetails" className="menu-link px-5" data-test-id="user-menu__account-settings-link">
            Account Settings
          </Link>
        </div>

        <div className="menu-item px-2">
          <a onClick={logout} className="menu-link px-5" data-test-id="user-menu__sign-out-link">
            Sign Out
          </a>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { HeaderUserMenu };
